import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import Lightbox from 'react-images'
import { Button } from 'reactstrap'
import {
  sale_product_pdf,
  sale_product_video,
  sale_product_images,
} from '../../static/images/manual'

export default class Manual extends React.Component {
  state={ currentImage: 0 }
  handleClickImage = () => {
    if (this.state.currentImage === sale_product_images.length - 1) return
    this.gotoNext()
  }
  gotoImage = (index) => {
    this.setState({ currentImage: index })
  }
  gotoNext = () => {
    this.setState({ currentImage: this.state.currentImage + 1 })
  }
  gotoPrevious = () => {
    this.setState({ currentImage: this.state.currentImage - 1 })
  }
  closeImage = () => {
    this.setState({
      currentImage: 0,
      isOpen: false,
    })
    this.props.closeManual()
  }
  render() {
    const downloadPDF = (
      <ButtonGroup>
        <PDFButton
          onClick={ () => window.open(sale_product_pdf, '_blank') }
        >PDF
        </PDFButton>
        <VideoButton
          onClick={ () => window.open(sale_product_video, '_blank') }
        >Video Tutorial
        </VideoButton>
      </ButtonGroup>
    )

    return (
      <Lightbox
        images={ sale_product_images }
        backdropClosesModal={ true }
        enableKeyboardInput={ true }
        showThumbnails={ true }
        currentImage={ this.state.currentImage }
        isOpen={ get(this.props, 'isOpen', false) }
        onClickPrev={ this.gotoPrevious }
        onClickNext={ this.gotoNext }
        onClickImage={ this.handleClickImage }
        onClickThumbnail={ this.gotoImage }
        onClose={ this.closeImage }
        customControls={ [downloadPDF] }
      />
    )
  }
}

Manual.propTypes = {
  closeManual: PropTypes.func,
}
Manual.defaultProps = {
  closeManual: () => {},
}

const PDFButton = styled(Button)`
  width: 80px;
  height: 30px;
  font-size: 12px;
  font-family: Gotham;
  color: white;
  background-color: #428BCA;
`

const VideoButton = styled(PDFButton)`
  width: 130px;
  margin-left: 8px;
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/sale-product/manual.js